export const setToken = (value: string): void =>
  localStorage.setItem("access_token", value);
export const getToken = (): string =>
  localStorage.getItem("access_token") || "";
export const removeToken = (): void => localStorage.removeItem("access_token");
